import { Box, Tooltip } from "@mui/material"

// Wraps a Tooltip+Box around children, showing the tooltip only when `condition` is true.
//
// Always renders the same JSX structure (Tooltip > Box > children) so React doesn't
// unmount and remount the children when `condition` flips. When condition is false,
// the tooltip's title is empty and MUI shows nothing — same visual result as not
// wrapping at all, but the children's React fiber stays stable.
//
// The Box is required (per MUI docs) so that disabled components can still trigger
// the tooltip on hover; keeping it always-rendered makes the wrapper invisible to
// layout changes when `condition` toggles.
export function IfTooltip({ condition, title, children }) {
    return (
        <Tooltip title={condition ? title : ""} enterDelay={0} leaveDelay={0}>
            <Box component="span" sx={{ display: "inline-block", pointerEvents: "auto" }}>
                {children}
            </Box>
        </Tooltip>
    )
}
